import * as React from 'react';
import {colors} from "../ui-components";

const svgDownload = props => {
  const { fill = colors.crederaRed } = props;

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15 9.5H19L12 16.5L5 9.5H9V3.5H15V9.5ZM19 20.5V18.5H5V20.5H19Z" fill={fill}/>
    </svg>
  );
};

export default svgDownload;
